import { RouteConfig } from 'vue-router';
import { RouteName } from '../routes.constants';
import { lightTopNavigation, modalGuard } from '../../services';
import { ModalSize } from '@gig/magic-common';

const getTournamentComponent =
    (component: keyof typeof import('./tournaments.chunk')) => async () => {
        const chunk = await import(
            /* webpackChunkName: "games" */
            './tournaments.chunk'
        );
        return chunk[component];
    };

export const TournamentsRoutes: RouteConfig[] = [
    {
        name: RouteName.TOURNAMENTS,
        path: '',
        component: getTournamentComponent('TournamentsPage'),
        meta: {
            ...lightTopNavigation('tournaments.title'),
        },
        children: [
            {
                name: RouteName.TOURNAMENTS_STARTING_SOON,
                path: 'starting-soon',
                component: getTournamentComponent(
                    'TournamentsStartingSoonPage',
                ),
            },
            {
                name: RouteName.TOURNAMENTS_HISTORY,
                path: 'history',
                component: getTournamentComponent('TournamentsHistoryPage'),
            },
            {
                name: RouteName.TOURNAMENTS_INFO,
                path: 'info',
                component: getTournamentComponent('TournamentsInfoModal'),
                meta: {
                    ...modalGuard(
                        getTournamentComponent('TournamentsInfoModal'),
                        'tournaments.how-work.title',
                        {
                            desktopOnly: false,
                            options: {
                                size: ModalSize.LARGE,
                                backArrow: false,
                            },
                        },
                    ),
                },
            },
        ],
    },
];
